import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import DisplayView from '../housekiosk/components/Display/DisplayView';
import { UserContext } from '../contexts/UserContext';

export default function HouseKioskLeaderboardPage() {
  const { userProfile } = useContext(UserContext);

  type UserProfileLike = {
    mainRole?: string;
    role?: string;
    roles?: string[];
  };

  const profile = userProfile as unknown as UserProfileLike | null | undefined;
  const roleText = (
    `${profile?.mainRole ?? ''} ${profile?.role ?? ''} ${
      Array.isArray(profile?.roles) ? profile!.roles.join(' ') : ''
    }`
  ).toUpperCase();

  const isTeacherLike = roleText.includes('TEACHER') || roleText.includes('ACORNLEAD');
  const isMascot = roleText.includes('MASCOT');
  const isKiosk = roleText.includes('KIOSK');
  const isStudent = roleText.includes('STUDENT');

  if (!isTeacherLike && !isMascot && !isKiosk && !isStudent) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <DisplayView />;
}
